import { Button } from "@/components/ui/button";

type Props = {
	page: number;
	pageSize: number;
	total: number;
	onPageChange: (page: number) => void;
};

export function IntelligenceListPagination({ page, pageSize, total, onPageChange }: Props) {
	const totalPages = Math.max(1, Math.ceil(total / pageSize));
	if (total <= pageSize) return null;

	const from = (page - 1) * pageSize + 1;
	const to = Math.min(page * pageSize, total);

	return (
		<div className="flex flex-wrap items-center justify-between gap-2 pt-2 text-sm">
			<p className="text-muted-foreground">
				Showing {from}–{to} of {total}
			</p>
			<div className="flex items-center gap-2">
				<Button
					type="button"
					size="sm"
					variant="outline"
					disabled={page <= 1}
					onClick={() => onPageChange(page - 1)}
				>
					Previous
				</Button>
				<span className="text-muted-foreground tabular-nums">
					Page {page} of {totalPages}
				</span>
				<Button
					type="button"
					size="sm"
					variant="outline"
					disabled={page >= totalPages}
					onClick={() => onPageChange(page + 1)}
				>
					Next
				</Button>
			</div>
		</div>
	);
}
